exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-026c24fc],.fade-leave-active[data-v-026c24fc]{transition:opacity 1.5s}.fade-enter[data-v-026c24fc],.fade-leave-to[data-v-026c24fc]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-026c24fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/task/Tasks.vue
// module id = 108
// module chunks = 0